<script>
  import { ClusterList } from "creditdesign-svelte-components";
  import LocationIcon from "../LocationIcon/index.svelte";
  import UniversityIcon from "../UniversityIcon/index.svelte";
  import WebsiteIcon from "../WebsiteIcon/index.svelte";
  import TrophyIcon from "../TrophyIcon/index.svelte";

  export let companyData;

  let { location, university, URL, winner } = companyData;
</script>

<style>
  li {
    display: grid;
    align-items: baseline;
    column-gap: 0.4em;
    grid-template-columns: 0.8em auto;
  }
</style>

<ClusterList clusterJustifyContent="space-between">
  {#if winner}
    <li>
      <TrophyIcon className="company-icon" height="0.8" title="" />
      Winner of the Spinoff Prize 2020
    </li>
  {/if}

  {#if location}
    <li>
      <LocationIcon className="company-icon" height="0.8" title="Location: " />
      {@html location}
    </li>
  {/if}

  {#if university}
    <li>
      <UniversityIcon
        className="company-icon"
        height="0.8"
        title="Spun off from: "
      />
      {@html university}
    </li>
  {/if}

  {#if URL}
    <li>
      <WebsiteIcon className="company-icon" height="0.8" title="Website: " />
      <a href="{URL}" target="_parent">
        {URL.replace(/https?:\/\//, '')
          .replace(/www./, '')
          .replace(/\/$/, '')}
      </a>
    </li>
  {/if}
</ClusterList>
